import { SwipeUp } from "@mui/icons-material"
import { Box } from "@mui/material"
import { Spin } from "antd"
import axios from "axios"
import React, { useState } from "react"
import { useAuthUser, useAuthHeader } from '../../../Services/Auth/sessionAuth'
import { Crypter } from "../../../Functions/Security/Crypter"
import formatNumber from "../../../Functions/Traitement/FormatNumber"
import SweetAlert from "../../../Functions/Traitement/SweetAlert"
import Utilisateur from "../../../Models/Utilisateur"
import InputForm from "../../InputT"
import SearchModal from "../../SearchModal"
import SelectOption from "../../SelectOption"
import ViewImages from "../../ViewImages"
import ParamsPicklist from "../../../Types/ParamsPicklist"
import { useNavigate } from "react-router-dom"
import Datas from "../../../Data/Data.json"
import SearchInput from "../../SearchInput"
import Billetage from "../../Billetage"


function Tab1(props: { form?: any }) {

    // USER SESSION
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

    let searchAgence: ParamsPicklist = { CodeAgence: user.codage, Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Init: "", Colagence: '101', Choix: 22 }

    return (
        <div className='tabItemAuto'>
            <Box fontStyle="inherit" className='border border-left' width={"85%"} position={"absolute"}>
                <Box display={"flex"} fontStyle={"inherit"}>
                    <SearchInput form={props.form} Titre='Recherche Agence' label='Agence' name='CODAGE' Parametre={searchAgence} />
                    <hr />
                    <InputForm taille={500} label="Reférence" icon={<SwipeUp color='disabled' fontSize='small' />} name='NUMRAP' type='text' error='mobile' />
                </Box>
                <legend></legend>
                <Box display={"flex"} fontStyle="inherit" >
                    <Box fontStyle="inherit" >
                        <InputForm disabled width={9} icon={<SwipeUp color='disabled' fontSize='small' />} label='Montant Opérat°' name='MONTAN' type={'text'} />
                        <InputForm disabled width={9} icon={<SwipeUp color='disabled' fontSize='small' />} label='Code opération' name='CDLBEC' type={'text'} />
                        <InputForm disabled width={9} icon={<SwipeUp color='disabled' fontSize='small' />} label='Compte' name='NUMCPT' type={'text'} />
                    </Box>
                    <Box fontStyle="inherit" >
                        <InputForm label='Sens opération' disabled width={9} icon={<SwipeUp color='disabled' fontSize='small' />} name='SENSOP' type='TEXT' error='mobile' />
                        <InputForm label='Utilisateur' disabled width={9} icon={<SwipeUp color='disabled' fontSize='small' />} name='UTISAI' type='TEXT' error='mobile' />
                        <InputForm disabled label='Libellé opération' icon={<SwipeUp color='disabled' fontSize='small' />} name='LIBOPE' type='TextArea' error='mobile' />
                    </Box>

                    <Box fontStyle="inherit" >
                        <InputForm disabled width={9} icon={<SwipeUp color='disabled' fontSize='small' />} label='Nom Client' name='REMETT' type={'text'} />
                        <InputForm disabled width={9} icon={<SwipeUp color='disabled' fontSize='small' />} label='CNI Remettant' name='cniremet' type={'text'} />
                        <InputForm disabled label='N° Tel' icon={<SwipeUp color='disabled' fontSize='small' />} name='teleph' type='text' error='mobile' />
                    </Box>
                </Box>
                <legend>Bielletage</legend><Box display={"flex"} fontStyle="inherit">
                    <Box fontStyle="inherit" >
                        <Box fontStyle={"inherit"} marginTop={-2} className='bordure1'>
                            <InputForm disabled width={11} label='Billet de 10 000' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMBO1' type='number' error='mobile' defaultValue={0} />
                            <InputForm disabled width={11} label='Billet de 5 000' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMBO2' type='number' error='mobile' defaultValue={0} />
                            <InputForm disabled width={11} label='Billet de 2 000' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMBO3' type='number' error='mobile' defaultValue={0} />
                            <InputForm disabled width={11} label='Billet de 1 000' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMBO4' type='number' error='mobile' defaultValue={0} />
                            <InputForm disabled width={11} label='Billet de 500' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMBO5' type='number' error='mobile' defaultValue={0} />
                        </Box>
                    </Box><hr />
                    <Box fontStyle={"inherit"}>
                        <Box display={"flex"} fontStyle={"inherit"} marginTop={-2} className='bordure1'>
                            <Box fontStyle="inherit" >
                                <InputForm disabled width={11} label='Pièce de 500' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMBO6' type='number' error='mobile' defaultValue={0} />
                                <InputForm disabled width={11} label='Pièce de 100' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMBO7' type='number' error='mobile' defaultValue={0} />
                                <InputForm disabled width={11} label='Pièce de 50' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMBO8' type='number' error='mobile' defaultValue={0} />
                                <InputForm disabled width={11} label='Pièce de 25' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMBO9' type='number' error='mobile' defaultValue={0} />
                                <InputForm disabled width={11} label='Pièce de 10' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB10' type='number' error='mobile' defaultValue={0} />
                            </Box><hr />
                            <Box fontStyle="inherit" >
                                <InputForm disabled width={11} label='Pièce de 5' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB11' type='number' error='mobile' defaultValue={0} />
                                <InputForm disabled width={11} label='Pièce de 2' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB12' type='number' error='mobile' defaultValue={0} />
                                <InputForm disabled width={11} label='Pièce de 1' icon={<SwipeUp color='disabled' fontSize='small' />} name='NOMB13' type='number' error='mobile' defaultValue={0} />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </div>
    )
}

export default Tab1;